import React, { useState } from "react";
import Reveal from "../Reveal";
import { GALLERY, GALLERY_CATEGORIES } from "../../../lib/site";

const GalleryGrid = ({ heading = "Recent Northern Arizona Projects", showIntro = true, categorized = false }) => {
  const [filter, setFilter] = useState("All");
  const items = filter === "All" ? GALLERY : GALLERY.filter((g) => g.category === filter);

  return (
    <section className="py-20 md:py-24 bg-[#0A0A0A]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        {showIntro && (
          <div className="text-center max-w-2xl mx-auto mb-10">
            <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">Our Work</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mt-2">{heading}</h2>
            <p className="text-zinc-400 text-base md:text-lg mt-3">
              Real floors, installed by Tyler and the PRYME team across Prescott, Sedona, Flagstaff and beyond.
            </p>
          </div>
        )}

        {categorized && (
          <div className="flex flex-wrap gap-2 mb-8 justify-center">
            {GALLERY_CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                data-testid={`gallery-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-4 py-2 text-sm font-semibold uppercase tracking-wider border transition-colors ${
                  filter === c ? "border-[#C69453] bg-[#C69453]/5 text-white" : "border-zinc-800 text-zinc-400 hover:text-white"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((g, i) => (
            <Reveal key={g.label} delay={(i % 3) * 0.06}>
              <div className="group relative overflow-hidden border border-zinc-800 aspect-[4/3]" data-testid={`gallery-item-${i}`}>
                <img src={g.src} alt={`${g.label} — floor coating in ${g.city}, Arizona`} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-5">
                  <p className="text-[#C69453] text-xs uppercase tracking-widest font-semibold">{g.city}</p>
                  <h3 className="text-white font-semibold text-lg">{g.label}</h3>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GalleryGrid;
